/* eslint-disable no-console */
import EditListingPricingForm from './EditListingPricingForm';

export const Empty = {
  component: EditListingPricingForm,
  props: {
    onSubmit: values => {
      
    },
    saveActionMsg: 'Save price',
    updated: false,
    updateInProgress: false,
    disabled: false,
    ready: false,
  },
  group: 'forms',
};
